import clsx from "clsx";
import getEmoteMessageContentByTemplate from "@/domains/chat/helpers/getContentByChatTemplate";
import getPlayerContent from "@/domains/chat/helpers/getPlayerContent";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";

export default function ChatEmoteMessage({ message, settings }: MessageProps) {
  const { showTime } = settings;

  const content = getEmoteMessageContentByTemplate(message);

  return (
    <div className={clsx("w-full text-[#e66dec]")}>
      {showTime && <Time date={message.date} />} {content.secured && "🛡️ "}
      <span>{getPlayerContent(message)}</span> {content.text}
    </div>
  );
}
